import { useState } from "react";

const MAX_RANGE_DAYS = 92;

function isoDaysAgo(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

/** Pages seed their own from/to with this. Defaulting inside the picker's
 *  mount effect meant the first render issued a from=&to= request that the
 *  API answers with 400 before the real one goes out. */
export function defaultRange(): { from: string; to: string } {
  return { from: isoDaysAgo(30), to: isoDaysAgo(0) };
}

interface Props {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
}

export function DateRangePicker({ from, to, onChange }: Props) {
  const [localFrom, setLocalFrom] = useState(from);
  const [localTo, setLocalTo] = useState(to);
  const [error, setError] = useState<string | null>(null);

  const tryChange = (f: string, t: string) => {
    if (new Date(t) < new Date(f)) {
      setError("'to' must be on or after 'from'");
      return;
    }
    const days = (new Date(t).getTime() - new Date(f).getTime()) / 86400000;
    if (days > MAX_RANGE_DAYS) {
      setError(`date range exceeds ${MAX_RANGE_DAYS} days`);
      return;
    }
    setError(null);
    onChange(f, t);
  };

  return (
    <div>
      <label>
        From
        <input
          type="date"
          aria-label="From"
          value={localFrom}
          onChange={(e) => {
            setLocalFrom(e.target.value);
            tryChange(e.target.value, localTo);
          }}
        />
      </label>
      <label>
        To
        <input
          type="date"
          aria-label="To"
          value={localTo}
          onChange={(e) => {
            setLocalTo(e.target.value);
            tryChange(localFrom, e.target.value);
          }}
        />
      </label>
      {error && <p style={{ color: "var(--red)" }}>{error}</p>}
    </div>
  );
}
